import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

void i18n
  .use(Backend) // Подключение бэкенда i18next
  .use(LanguageDetector) // Автоматическое определение языка
  .use(initReactI18next) // модуль инициализации
  .init({
    fallbackLng: "en", // Стандартный язык
    debug: false,
    detection: {
      order: ["queryString", "cookie"],
      caches: ["cookie"], // Правильное свойство
    },
    interpolation: {
      escapeValue: false, // не экранируем, для React это не требуется
    },
    ns: ["translation"], // Пространства имён
    defaultNS: "translation",
  });

export default i18n;
